<template>
	<div class="container">

		<el-scrollbar id="menuWarpper" style="height:calc(99%);background-color: #FFFFFF;margin-top: 0px;">
			<div class="main">
				<!-- <el-button class="fanhuiBtn" @click="fanhui()">返回</el-button> -->
				<div class="yonghuminglabe">新建工单</div>
				<div class="header-con">
					<div class="maina">
						<el-form :model="form" :rules="formRule" ref="form" label-width="140px" label-position="right"
							style="display: inline">
							<el-row>

								<el-col :span="12">
									<el-form-item style="width:100%" label="选择客户：" prop="xuanzekehu">

										<div>
											<!-- <el-button class="medium" @click="double">{{xuanzekehu}}
									</el-button> -->
											<el-input style="width:100%" type="text" v-model="form.xuanzekehu"
												@keyup.enter.native="double" placeholder="点回车查询客户" ref="xuanzekehu"
												@dblclick.native="double" clearable>
											</el-input>
										</div>
									</el-form-item>
								</el-col>
								<el-col :span="12">
									<el-form-item style="width:100%" label="客户联系人：">
										<el-input style="width:100%" type="text" v-model="lianxiren" ref="lianxiren"
											@keyup.enter.native="xzlianxidianhua" placeholder="请输入您的姓名">
										</el-input>

									</el-form-item>
								</el-col>
								<el-col :span="12">

									<el-form-item style="width:100%" label="客户联系方式：">
										<el-input style="width:100%" type="text" v-model="lianxidianhua"
											ref="lianxidianhua" @keyup.enter.native="xzchanpinxian"
											placeholder="请输入您的联系方式">
										</el-input>
									</el-form-item>

								</el-col>
								<el-col :span="12">
									<el-form-item style="width:100%" label="产品线：" prop="person">
										<!-- <el-select class="form-item-inputcpx" v-model="form.person" filterable remote
									reserve-keyword placeholder="输入关键词搜索" :remote-method="getPerson" :loading="loading"
									@click.native="getPerson('')">
									<el-option v-for="item in staff" :key="item.Code" :label="item.Name" :value="item.Code">
									</el-option>
								</el-select> -->
										<el-select style="width:100%;" v-model="form.person" filterable
											ref="chanpinxian" placeholder="输入关键词搜索" :filter-method="bindSelectChange"
											@change="dianjichanpinxian" popper-class="eloption"
											>
											<el-option v-for="item in staff" :key="item.Code" :label="item.Name"
												:value="item.Code" :value-key="item.Code">
											</el-option>
										</el-select>
									</el-form-item>
								</el-col>
								<el-col :span="12">

									<el-form-item style="width:100%" label="问题类型：" prop="wentileixing">

										<el-select style="width:100%" v-model="form.wentileixing" filterable
											ref="wentileixing" placeholder="输入关键词搜索">
											<el-option v-for="item in WenTileixingList" :key="item.Code"
												:label="item.Name" :value="item.Code">
											</el-option>
										</el-select>

									</el-form-item>
								</el-col>
								<el-col :span="12">

									<el-form-item style="width:100%" label="下发到未结单：" prop="xiafadaoweijiedan">

										<el-select style="width:100%" v-model="form.xiafadaoweijiedan" filterable
											ref="xiafaweijiedan" placeholder="输入关键词搜索">
											<el-option v-for="item in xiafadaoweijiedanList" :key="item.Code"
												:label="item.Name" :value="item.Code">
											</el-option>
										</el-select>

									</el-form-item>
								</el-col>
								<el-col :span="12">

									<el-form-item style="width:100%" label="远程工具：">

										<el-select style="width:100%" v-model="yuanchenggongju" filterable
											ref="yuanchenggongju" :filter-method="bindSelectChangeyc"
											@change="dianjichanpinxianyc" placeholder="输入关键词搜索" clearable>
											<el-option v-for="item in YuanChengGongJuList" :key="item.Code"
												:label="item.Name" :value="item.Code">
											</el-option>
										</el-select>

									</el-form-item>
								</el-col>
								<el-col :span="12">
									<el-form-item style="width:100%" label="远程账号：">
										<el-input style="width:100%" type="text" ref="yuanchengzhanghao"
											v-model="yuanchengzhanghao" @keyup.enter.native="xzyuanchengmima"
											placeholder="请输入您的远程账号">
										</el-input>

									</el-form-item>
								</el-col>
								<el-col :span="12">
									<el-form-item style="width:100%" label="远程账号密码：">
										<el-input style="width:100%" type="text" ref="yuanchengmima"
											v-model="yuanchengmima" @keyup.enter.native="xzmiaoshu"
											placeholder="请输入您的远程账号密码">
										</el-input>

									</el-form-item>
								</el-col>
								<div v-if="form.xiafadaoweijiedan=='N'">
									<el-col :span="12">
										<el-form-item style="width:100%" label="预计完成时间：" prop="yujiwanchengshijian">

											<el-date-picker style="width:100%" v-model="form.yujiwanchengshijian"
												type="datetime" placeholder="选择日期时间">
											</el-date-picker>
										</el-form-item>
									</el-col>
								</div>



							</el-row>





						</el-form>
					</div>
					<el-card class="mainxjgda">
						<el-form :model="form" :rules="formRule" ref="form" label-width="100px" label-position="right">

							<el-form-item label="描述：" prop="miaoshu">
								<el-input style="margin-left: 10px;width:96%" type="textarea" :rows="8" ref="miaoshu"
									placeholder="请输入内容" v-model="form.miaoshu">
								</el-input>

							</el-form-item>

							<div class="shangchuantupian">
								<div class="shangchuantupianx">
									<!-- <el-upload action="#" ref="pictureUpload" list-type="picture-card"
										:on-change="uploadChange" :auto-upload="false" multiple>
										<i slot="default" class="el-icon-plus"></i>
										<div slot="file" slot-scope="{file}">
											<img class="el-upload-list__item-thumbnail" :src="file.url" alt="">
											<span class="el-upload-list__item-actions">
												<span class="el-upload-list__item-preview"
													@click="handlePictureCardPreview(file)">
													<i class="el-icon-zoom-in"></i>
												</span>
												<span v-if="!disabled" class="el-upload-list__item-delete"
													@click="handleRemove(file)">
													<i class="el-icon-delete"></i>
												</span>
											</span>
										</div>
									</el-upload> -->
									<el-upload action="#" ref="pictureUpload" list-type="picture-card"
										:on-change="uploadChange" :auto-upload="false" multiple>
										<i slot="default" class="el-icon-plus"></i>
										<div slot="file" slot-scope="{file}">

											<img class="el-upload-list__item-thumbnail"
												src="../../assets/img/wenjianmorentu.png" style="height: 150px;" alt=""
												v-if="file.name.search('.doc') !=-1||file.name.search('.ppt') !=-1||file.name.search('.htm') !=-1||file.name.search('.txt') !=-1||file.name.search('.pdf') !=-1||file.name.search('.xls') !=-1">

											<img class="el-upload-list__item-thumbnail" :src="file.url" alt=""
												v-if="file.name.search('.png') !=-1||file.name.search('.PNG') !=-1||file.name.search('.jpg') !=-1||file.name.search('.JPG') !=-1||file.name.search('.jpeg') !=-1||file.name.search('.JPEG') !=-1||file.name.search('.PDD') !=-1||file.name.search('.pdd') !=-1||file.name.search('.PSD') !=-1||file.name.search('.psd') !=-1||file.name.search('.GIF') !=-1||file.name.search('.gif') !=-1">
<img class="el-upload-list__item-thumbnail" :src="file.url" alt=""
												v-else>

											<!-- <div class="wenjianmingchengzs"
												v-if="file.name.search('.doc') !=-1||file.name.search('.ppt') !=-1||file.name.search('.htm') !=-1||file.name.search('.txt') !=-1||file.name.search('.pdf') !=-1||file.name.search('.xls') !=-1">
												{{file.name}}
											</div> -->

											<div class="wenjianmingchengzs">
												{{file.name}}
											</div>
											<span class="el-upload-list__item-actions">

												<span class="el-upload-list__item-preview"
													@click="handlePictureCardPreview(file)"
													v-if="file.name.search('.png') !=-1||file.name.search('.PNG') !=-1||file.name.search('.jpg') !=-1||file.name.search('.JPG') !=-1||file.name.search('.jpeg') !=-1||file.name.search('.JPEG') !=-1||file.name.search('.PDD') !=-1||file.name.search('.pdd') !=-1||file.name.search('.PSD') !=-1||file.name.search('.psd') !=-1||file.name.search('.GIF') !=-1||file.name.search('.gif') !=-1">
													<i class="el-icon-zoom-in"></i>
												</span>
												<span v-if="!disabled" class="el-upload-list__item-delete"
													@click="handleRemove(file)">
													<i class="el-icon-delete"></i>
												</span>
											</span>
										</div>
									</el-upload>
									<el-image-viewer class="fankuiImage" v-if="dialogVisible"
										:initial-index="this.index" :on-close="closeViewer" :url-list="this.urlList" />

								</div>

							</div>


						</el-form>

					</el-card>
					<el-col :span="9">
						<div class="shangchuantupian">


						</div>
					</el-col>
					<!-- 	<el-col :span="5">
						<el-button class="tijiaobtn" type="success" :disabled="scoped" @click="baocuncaogao()">保存草稿
						</el-button>
					</el-col> -->
					<el-col :span="6">

						<el-button class="tijiaobtn" type="primary" @click="submitForm()" :disabled="isTiJiao">提交
						</el-button>
					</el-col>
					<el-col :span="9">
						<div class="shangchuantupian">


						</div>
					</el-col>
				</div>
			</div>
		</el-scrollbar>
		<!-- 选择客户 -->
		<el-dialog title="选择客户" :visible.sync="formDialog" width="80%" height="80%">
			<div class="containera">
				<el-card class="headera">
					<div class="header-cona">
						<el-form class="header-con-form" :inline="true" @submit.native.prevent>
							<el-form-item class="header-con-form-item" label="客户姓名:">
								<el-input v-model="form.xuanzekehu" style="width: 200px" placeholder="请输入"
									ref="kehuchaxun" @change="handleAddItem(1)" @keyup.enter.native="handleAddItem(1)">
								</el-input>
							</el-form-item>
							<el-button type="primary" @click="handleAddItem(1)" :disabled="isChaXun">查询</el-button>
						</el-form>


					</div>
					<div>

					</div>
				</el-card>
				<div class="main" v-bind:style="{height:EchartsHeight}">
					<el-table :data="tableData" height="100%" highlight-current-row resizable stripe border
						@row-dblclick="handledbClick">
						<el-table-column align="center" type="index" label="序号" width="50">
						</el-table-column>
						<el-table-column align="center" prop="BUSINESSNAME" label="客户名称" min-width="180">
						</el-table-column>
						<el-table-column align="center" prop="BUSINESSCODE" label="客户编号">
						</el-table-column>
						<el-table-column align="center" prop="CONTACT" label="客户联系人">
						</el-table-column>
						<el-table-column align="center" prop="TELEPHONE" label="客户联系电话">
						</el-table-column>



						<el-table-column align="center" label="操作" fixed="right" width="300px">
							<template slot-scope="scope">
								<el-button type="primary" @click="viewDoc(scope)">选择</el-button>

							</template>
						</el-table-column>
					</el-table>
				</div>
				<div class="footer" ref="footer">
					<pagination :allPage="allPage" :pageSize="pageSize" :currIndex="currPage" @hanSiChange="hanSiChange"
						@hanCurrChange="hanCurrChange"></pagination>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import PinyinMatch from "pinyin-match";
	import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
	export default {
		components: {
			ElImageViewer
		},

		name: "shangchuanshipin",
		data() {
			return {
				isChaXun:false,
				isTiJiao:false,
				EchartsHeight: (document.body.clientHeight - 200) + 'px',
				fileList: [],
				fileListhc: [],
				showViewer: false, // 显示查看器
				urlList: [],
				index: 0,
				kehumingcheng: "",
				kehubianhao: "",
				currPage: 1,
				pageSize: 50,
				allPage: 0,
				WenTileixingList: [],
				YuanChengGongJuList: [],
				YuanChengGongJuListcopy: [],
				YuanChengGongJuListz: [],
				xiafadaoweijiedanList: [{
						Code: "Y",
						Name: "是"
					},
					{
						Code: "N",
						Name: "否"
					}
				],
				tableData: [], //客户数组

				yonghuming: JSON.parse(localStorage.getItem("userInfo")).NAME,
				formDialog: false,
				dialogImageUrl: '',
				dialogVisible: false,
				disabled: false,
				qianyiyemingcheng: this.$route.query.qianyiyemingcheng,
				yuanchengzhanghao: "",
				yuanchengmima: "",
				lianxiren: "",
				lianxidianhua: "",
				yuanchenggongju: "", //远程工具
				/**表单 */
				form: {
					miaoshu: "", //描述
					person: "", //产品线
					wentileixing: "", //问题类型
					xiafadaoweijiedan: "Y", //是否下发

					xuanzekehu: "",
					yujiwanchengshijian: "", //预计完成时间

				},

				staffcopy: [],
				staff: [], //产品线
				staffz: [], //产品线
				shops: [], //检索的店铺
				allShops: [], //所有的店铺
				loading: false, //搜索加载状态
				scoped: false,

				/*表单规则 */
				formRule: {
					xuanzekehu: [{
						required: true,
						message: "请选择客户",
						// trigger: "blur"
					}],
					name: [{
						required: true,
						message: "请输入",
						trigger: "blur"
					}],
					dianhua: [{
						required: true,
						message: "请输入",
						trigger: "blur"
					}],
					miaoshu: [{
						required: true,
						message: "请输入",
						trigger: "blur"
					}],
					person: [{
						required: true,
						message: "请选择",
						trigger: "blur"
					}],
					wentileixing: [{
						required: true,
						message: "请选择",
						trigger: "blur"
					}],
					xiafadaoweijiedan: [{
						required: true,
						message: "请选择",
						trigger: "blur"
					}],
					yuanchenggongju: [{
						required: true,
						message: "请选择",
						trigger: "blur"
					}],
					yujiwanchengshijian: [{
						required: true,
						message: "请选择",
						trigger: "blur"
					}]

				},
			};
		},

		mounted() {

			// this.$nextTick(() => {
			// 	this.$refs.xuanzekehu.focus()
			// })
			this.qianyiyemingcheng = this.$route.query.qianyiyemingcheng;
			const that = this;
			window.onresize = () => {
				// return (() => {
				window.screenHeight = document.body.clientHeight
				that.EchartsHeight = (window.screenHeight - 200) + 'px'
				// })()
			}



			this.addDate()
			this.getPerson()
			this.getWenTileixing()
			this.getYuanChengGongJu()
			this.currPage = 1;
			this.handleAddItem(1)
			// if (JSON.parse(localStorage.getItem("kfxinjiangongdantp")) != null) {
			// 	// if (JSON.parse(localStorage.getItem("kfxinjiangongdantp")).length > 0) {
			// 		this.fileList = JSON.parse(localStorage.getItem("kfxinjiangongdantp"));

			// 	// }
			// }
			// console.log(this.fileList)

		},
		activated() {
			this.qianyiyemingcheng = this.$route.query.qianyiyemingcheng;
			const that = this;
			window.onresize = () => {
				// return (() => {
				window.screenHeight = document.body.clientHeight
				that.EchartsHeight = (window.screenHeight - 200) + 'px'
				// })()
			}

			this.addDate()
			this.getPerson()
			this.getWenTileixing()
			this.getYuanChengGongJu()
			this.currPage = 1;
			this.handleAddItem(1)

		},

		methods: {
			dianjichanpinxianyc() {
				this.YuanChengGongJuList = this.YuanChengGongJuListz;
			},
			bindSelectChangeyc(val) {

				if (val) {
					this.YuanChengGongJuList = this.YuanChengGongJuListcopy.filter((item) => {
						return PinyinMatch.match(item.Name, val) //(需要过滤的名称，输入的关键词)
					})
				} else {
					this.YuanChengGongJuList = this.YuanChengGongJuListcopy
				}

			},
			dianjichanpinxian() {
				this.staff = this.staffz;
				this.$nextTick(() => {
					this.$refs.wentileixing.focus()
				})
			},


			bindSelectChange(val) {

				if (val) {
					this.staff = this.staffcopy.filter((item) => {
						return PinyinMatch.match(item.Name, val) //(需要过滤的名称，输入的关键词)
					})
				} else {
					this.staff = this.staffcopy
				}

			},
			addDate() {
				let nowDate = new Date();
				let date = {
					year: nowDate.getFullYear(),
					month: nowDate.getMonth() + 1,
					date: nowDate.getDate(),
				};

				if (date.month < 10) {
					date.month = '0' + date.month; //补齐
				}
				if (date.date < 10) {
					date.date = '0' + date.date; //补齐
				}
				// let shijianshuzu = [];
				let shijian = date.year + "-" + date.month + "-" + date.date;


				this.form.yujiwanchengshijian = shijian + " 23:59:59";

			},
			//客户双击
			handledbClick(row) {


				this.kehumingcheng = row.BUSINESSNAME;
				this.kehubianhao = row.BUSINESSCODE;
				this.lianxiren = row.CONTACT;
				this.lianxidianhua = row.TELEPHONE;
				this.formDialog = false;
				if (this.kehumingcheng != "") {
					this.form.xuanzekehu = this.kehumingcheng;
				} else {
					this.form.xuanzekehu = "";
				}
				this.$nextTick(() => {
					this.$refs.lianxiren.focus()
				})
			},
			/**查看分类下文档 */
			viewDoc(row) {

				this.kehumingcheng = row.row.BUSINESSNAME;
				this.kehubianhao = row.row.BUSINESSCODE;
				this.lianxiren = row.row.CONTACT;
				this.lianxidianhua = row.row.TELEPHONE;
				this.formDialog = false;
				if (this.kehumingcheng != "") {
					this.form.xuanzekehu = this.kehumingcheng;
				} else {
					this.form.xuanzekehu = "";
				}
				this.$nextTick(() => {
					this.$refs.lianxiren.focus()
				})
			},
			uploadChange(file) {

				// this.imageFileData = file.raw;
				this.fileList.push(file.raw);
				this.fileListhc.push(file)
				console.log(JSON.stringify(this.fileListhc))
			},
			/**提交选项 */
			submitForm() {


				this.$refs.form.validate((valid) => {
					if (valid) {

						if (this.form.miaoshu.length > 0 && this.form.miaoshu.trim().length == 0) {
							this.$message({
								message: "描述不能为空！",
								type: "error",
							});
						} else {

							if (this.kehumingcheng.length == 0) {
								this.$message({
									message: "请选择客户！",
									type: "error",
								});
							} else {
								let formData = new FormData();
								let userInfo = JSON.parse(localStorage.getItem("userInfo"))
								// formData.append('file', this.imageFileData)
								var mingzia = 'file';
								for (var i = 0, len = this.fileList.length; i < len; i++) {
									if (i == 0) {
										formData.append(mingzia, this.fileList[i])
									} else {
										formData.append(mingzia + i, this.fileList[i])
									}

								}

								// localStorage.setItem(
								// 	"kfxinjiangongdantp",
								// 	JSON.stringify(this.fileListhc)
								// );



								let data = {
									FEEDBACK: {
										ID: "",
										CODE: "",
										FEEDBACK_MESSAGE: "新建工单",
										FEEDBACK_USER: userInfo.NAME,
										CREATED_TIME: ""
									},
									ISSUED: this.form.xiafadaoweijiedan,
									REMOTE_MODE: this.yuanchenggongju,
									REMOTE_ACCOUNT: this.yuanchengzhanghao, //远程账号
									REMOTE_CIPHER: Buffer(this.yuanchengmima).toString('base64'), //远程密码
									PRODUCT_LINE: this.form.person, //产品线
									INFO_TYPE: this.form.wentileixing, //工单类型
									DESCRIBE: this.form.miaoshu, //工单描述
									CONTACTS: this.lianxiren, //联系人
									CONTACT_INFORMATION: this.lianxidianhua, //联系方式
									CUSTOMER_NAME: this.kehumingcheng, //客户名称
									CUSTOMER_NUMBER: this.kehubianhao, //客户编号
									ESTIMATED_TIME: this.form.yujiwanchengshijian
								};
								localStorage.setItem(
									"kfxinjiangongdan",
									JSON.stringify(data)
								);


								formData.append('param', JSON.stringify(data))
								this.scoped = true;
								this.isTiJiao=true;
								this.$request({
										method: "post",
										url: "Info/UploadInfo",
										data: formData,
									})
									.then(() => {
										this.isTiJiao=false;
										this.$message({
											message: "发起成功！",
											type: "success",
										});
										this.form.xuanzekehu = "";
										this.form.xiafadaoweijiedan = "Y";
										this.yuanchenggongju = "";
										this.yuanchengzhanghao = "";
										this.yuanchengmima = "";
										this.form.person = this.staff[0].Code;
										this.form.wentileixing = this.WenTileixingList[0].Code;
										this.form.miaoshu = "";
										this.lianxiren = "";
										this.lianxidianhua = "";
										this.kehubianhao = '';
										this.kehumingcheng = '';
										this.$refs['pictureUpload']['uploadFiles'] = [];
										this.fileList = [] //移除已上传的图片
										this.fileListhc = [] //移除已上传的图片
										this.scoped = false;
										// localStorage.removeItem("kfxinjiangongdan");
										// localStorage.removeItem("kfxinjiangongdantp");
										// console.log(JSON.parse(localStorage.getItem("kfxinjiangongdan")))
										// this.$router.push({ path: "weijiekongdan" });

									})
									.catch((err) => {
										this.isTiJiao=false;
										if (err == "Error: Request failed with status code 401") {
											this.$router.push({
												path: "/login",
											});
										}
									});
							}

						}
					}
				});
			},

			/**获取产品线 */
			getPerson() {
				this.loading = true;

				this.$request({
						method: "GET",
						url: "Dictionary/GetProducts",
					})
					.then((res) => {
						this.loading = false;
						if (res.Code == '0' || res.Code == 0) {
							var arr = [];

							var bdcpx = JSON.parse(localStorage.getItem("userInfo")).PRODUCT_LINE.split(',');

							for (var i in res.Data) {
								for (var j in bdcpx) {

									if (res.Data[i].Code == bdcpx[j]) {
										arr.push(res.Data[i])
									}

								}

							}
							this.staff = arr;
							this.staffz = arr;
							this.staffcopy = this.staff;


							if (this.staff.length > 0) {
								this.form.person = this.staff[0].Code;
							}
							if (JSON.parse(localStorage.getItem("kfxinjiangongdan")) != null) {

								this.form.xiafadaoweijiedan = JSON.parse(localStorage.getItem("kfxinjiangongdan"))
									.ISSUED;
								this.yuanchenggongju = JSON.parse(localStorage.getItem("kfxinjiangongdan"))
									.REMOTE_MODE;
								this.yuanchengzhanghao = JSON.parse(localStorage.getItem("kfxinjiangongdan"))
									.REMOTE_ACCOUNT; //远程账号
								var mima  =JSON.parse(localStorage.getItem("kfxinjiangongdan"))
									.REMOTE_CIPHER; //远程密码
								this.yuanchengmima =Buffer(mima, 'base64').toString()
								
								this.form.person = JSON.parse(localStorage.getItem("kfxinjiangongdan"))
									.PRODUCT_LINE; //产品线
								this.form.wentileixing = JSON.parse(localStorage.getItem("kfxinjiangongdan"))
									.INFO_TYPE; //工单类型
								this.form.miaoshu = JSON.parse(localStorage.getItem("kfxinjiangongdan"))
									.DESCRIBE; //工单描述
								this.lianxiren = JSON.parse(localStorage.getItem("kfxinjiangongdan")).CONTACTS; //联系人
								this.lianxidianhua = JSON.parse(localStorage.getItem("kfxinjiangongdan"))
									.CONTACT_INFORMATION; //联系方式
								this.kehumingcheng = JSON.parse(localStorage.getItem("kfxinjiangongdan"))
									.CUSTOMER_NAME; //客户名称
								this.kehubianhao = JSON.parse(localStorage.getItem("kfxinjiangongdan"))
									.CUSTOMER_NUMBER; //客户编号
								this.form.yujiwanchengshijian = JSON.parse(localStorage.getItem("kfxinjiangongdan"))
									.ESTIMATED_TIME;
								this.form.xuanzekehu = this.kehumingcheng

							}

						}

					})
					.catch((err) => {
						if (err == "Error: Request failed with status code 401") {
							this.$router.push({
								path: "/login",
							});
						}
					});
			},
			/**获取远程工具 */
			getYuanChengGongJu() {
				this.loading = true;

				this.$request({
						method: "GET",
						url: "Dictionary/GetRemoteTool",
					})
					.then((res) => {
						this.loading = false;
						if (res.Code == '0' || res.Code == 0) {
							this.YuanChengGongJuList = res.Data;
							this.YuanChengGongJuListcopy = this.YuanChengGongJuList;
							this.YuanChengGongJuListz = res.Data;
							if (JSON.parse(localStorage.getItem("kfxinjiangongdan")) != null) {

								this.form.xiafadaoweijiedan = JSON.parse(localStorage.getItem("kfxinjiangongdan"))
									.ISSUED;
								this.yuanchenggongju = JSON.parse(localStorage.getItem("kfxinjiangongdan"))
									.REMOTE_MODE;
								this.yuanchengzhanghao = JSON.parse(localStorage.getItem("kfxinjiangongdan"))
									.REMOTE_ACCOUNT; //远程账号
								var mima  =JSON.parse(localStorage.getItem("kfxinjiangongdan"))
									.REMOTE_CIPHER; //远程密码
								this.yuanchengmima =Buffer(mima, 'base64').toString()
								
								this.form.person = JSON.parse(localStorage.getItem("kfxinjiangongdan"))
									.PRODUCT_LINE; //产品线
								this.form.wentileixing = JSON.parse(localStorage.getItem("kfxinjiangongdan"))
									.INFO_TYPE; //工单类型
								this.form.miaoshu = JSON.parse(localStorage.getItem("kfxinjiangongdan"))
									.DESCRIBE; //工单描述
								this.lianxiren = JSON.parse(localStorage.getItem("kfxinjiangongdan")).CONTACTS; //联系人
								this.lianxidianhua = JSON.parse(localStorage.getItem("kfxinjiangongdan"))
									.CONTACT_INFORMATION; //联系方式
								this.kehumingcheng = JSON.parse(localStorage.getItem("kfxinjiangongdan"))
									.CUSTOMER_NAME; //客户名称
								this.kehubianhao = JSON.parse(localStorage.getItem("kfxinjiangongdan"))
									.CUSTOMER_NUMBER; //客户编号
								this.form.yujiwanchengshijian = JSON.parse(localStorage.getItem("kfxinjiangongdan"))
									.ESTIMATED_TIME;
								this.form.xuanzekehu = this.kehumingcheng

							}


						}

					})
					.catch((err) => {
						if (err == "Error: Request failed with status code 401") {
							this.$router.push({
								path: "/login",
							});
						}
					});
			},
			/**获取产品线 */
			getWenTileixing() {
				this.loading = true;

				this.$request({
						method: "GET",
						url: "Dictionary/GetGdLx",
					})
					.then((res) => {
						this.loading = false;
						if (res.Code == '0' || res.Code == 0) {
							this.WenTileixingList = res.Data;
							if (this.WenTileixingList.length > 0) {
								this.form.wentileixing = this.WenTileixingList[0].Code;
							}
							if (JSON.parse(localStorage.getItem("kfxinjiangongdan")) != null) {

								this.form.xiafadaoweijiedan = JSON.parse(localStorage.getItem("kfxinjiangongdan"))
									.ISSUED;
								this.yuanchenggongju = JSON.parse(localStorage.getItem("kfxinjiangongdan"))
									.REMOTE_MODE;
								this.yuanchengzhanghao = JSON.parse(localStorage.getItem("kfxinjiangongdan"))
									.REMOTE_ACCOUNT; //远程账号
								var mima  =JSON.parse(localStorage.getItem("kfxinjiangongdan"))
									.REMOTE_CIPHER; //远程密码
								this.yuanchengmima =Buffer(mima, 'base64').toString()
								
								this.form.person = JSON.parse(localStorage.getItem("kfxinjiangongdan"))
									.PRODUCT_LINE; //产品线
								this.form.wentileixing = JSON.parse(localStorage.getItem("kfxinjiangongdan"))
									.INFO_TYPE; //工单类型
								this.form.miaoshu = JSON.parse(localStorage.getItem("kfxinjiangongdan"))
									.DESCRIBE; //工单描述
								this.lianxiren = JSON.parse(localStorage.getItem("kfxinjiangongdan")).CONTACTS; //联系人
								this.lianxidianhua = JSON.parse(localStorage.getItem("kfxinjiangongdan"))
									.CONTACT_INFORMATION; //联系方式
								this.kehumingcheng = JSON.parse(localStorage.getItem("kfxinjiangongdan"))
									.CUSTOMER_NAME; //客户名称
								this.kehubianhao = JSON.parse(localStorage.getItem("kfxinjiangongdan"))
									.CUSTOMER_NUMBER; //客户编号
								this.form.yujiwanchengshijian = JSON.parse(localStorage.getItem("kfxinjiangongdan"))
									.ESTIMATED_TIME;
								this.form.xuanzekehu = this.kehumingcheng


							}


						}

					})
					.catch((err) => {
						if (err == "Error: Request failed with status code 401") {
							this.$router.push({
								path: "/login",
							});
						}
					});
			},
			//查询客户
			handleAddItem(index) {
				this.loading = true;
				this.isChaXun=true;
				this.$request({
						method: "GET",
						url: 'ACCOUNT/GetKhList?khxm=' + encodeURIComponent(this.form.xuanzekehu) +
							"&pageIndex=" + encodeURIComponent(index) + "&pageSize=" + encodeURIComponent(this
								.pageSize)
					})
					.then((res) => {
						this.isChaXun=false;
						this.loading = false;
						if (res.Code == '0' || res.Code == 0) {
							this.tableData = res.Data;
						}
						this.allPage = res.Total;

					})
					.catch((err) => {
						this.isChaXun=false;
						if (err == "Error: Request failed with status code 401") {
							this.$router.push({
								path: "/login",
							});
						}
					});
			},

			/**分页size改变 */
			hanSiChange(val) {
				this.pageSize = val;
				this.handleAddItem(1);
			},
			/**当前页改变 */
			hanCurrChange(val) {
				this.currPage = val;
				this.handleAddItem(this.currPage);
			},
			/**刷新表格数据 */
			handleRefresh() {
				this.currPage = 1;
				this.handleAddItem(this.currPage);
			},


			double() {
				this.formDialog = true
				this.handleAddItem(1)
				this.$nextTick(() => {
					this.$refs.kehuchaxun.focus()
				})
			},
			sendMsg() {

				this.$emit('sendmsg', 'firstpage')

				this.$emit('addnum', 'firstpage')

			},
			handleRemove(file) {

				const index = this.fileList.findIndex(item => item.uid === file.uid)
				const indexa = this.$refs['pictureUpload']['uploadFiles'].findIndex(item => item.uid === file.uid)
				const indexhc = this.fileListhc.findIndex(item => item.uid === file.uid)
				this.$refs['pictureUpload']['uploadFiles'].splice(indexa, 1)
				this.fileList.splice(index, 1) //移除已上传的图片
				this.fileListhc.splice(indexhc, 1) //移除已上传的图片

			},
			handlePictureCardPreview(file) {

				this.urlList = [];
				this.urlList.push(file.url)
				this.dialogImageUrl = file.url;
				this.dialogVisible = true;
				this.index = file.index;
				this.showViewer = true;

			},
			closeViewer() {
				this.dialogVisible = false
			},

			fanhui() {
				this.$router.go(-1);
			},

			/**重置表单 */
			resetForm() {
				this.$refs.form.resetFields();
			},
			//回车事件
			xzlianxidianhua() {
				this.$nextTick(() => {
					this.$refs.lianxidianhua.focus()
				})
			},
			xzchanpinxian() {
				this.$nextTick(() => {
					this.$refs.chanpinxian.focus()
				})
			},
			xzwentileixing() {
				this.$nextTick(() => {
					this.$refs.wentileixing.focus()
				})
			},
			xiafaweijiedan() {
				this.$nextTick(() => {
					this.$refs.xiafaweijiedan.focus()
				})
			},
			xzyuanchenggongju() {
				this.$nextTick(() => {
					this.$refs.yuanchenggongju.focus()
				})
			},
			xzyuanchengzhanghao() {
				this.$nextTick(() => {
					this.$refs.yuanchengzhanghao.focus()
				})
			},
			xzyuanchengmima() {
				this.$nextTick(() => {
					this.$refs.yuanchengmima.focus()
				})
			},
			xzmiaoshu() {
				this.$nextTick(() => {
					this.$refs.miaoshu.focus()
				})
			},


		},
	};
</script>

<style scoped>
	.container {
		width: 100%;
		height: 100%;
		padding: 10px;
		box-sizing: border-box;
		background-color: #F0F0F0;
	}

	.containera {
		width: 100%;
		height: 100%;
		padding-left: 10px;
		margin-top: -10px;
		box-sizing: border-box;
		background-color: #FFFFFF;
	}

	.header {
		margin-top: 10px;
		margin-bottom: 15px;
		padding-left: 20px;
	}

	.headera {
		margin-bottom: 2px;
	}



	.fanhuiBtn {
		margin-top: 0px;
		margin-left: 0px;
		margin-bottom: 20px;
		display: inline-block;
	}

	.el-input {
		width: 100px;
	}

	.yonghuminglabe {
		margin-top: 30px;
		margin-left: 30px;
		margin-bottom: 0px;
		display: inline-block;
	}

	/* 主体容器 */
	.main {
		height: 100%;
		overflow: hidden;
		background-color: #fff;
		padding: 0px;
		box-sizing: border-box;
	}

	.tijiaobtn {
		margin-left: 100px;
		margin-top: 30px;
		width: 100px;
		margin-bottom: 20px;
	}

	.header-con {
		margin-left: 50px;
		margin-right: 50px;
		margin-top: 30px;
	}

	.header-cona {
		display: flex;
		align-items: center;
		height: 30px;
		margin-left: 30px;
	}


	.header-con-form {
		display: flex;
		align-items: center;
	}

	.header-con-form-item {
		margin-bottom: 0;
	}

	.wenjianmingchengzs {
		position: absolute;
		z-index: 0;
		width: 100%;
		bottom: 0px;
		color: #FFFFFF;
		text-align: center;
		background-color: #3D546F;

	}

	/**输入框宽度 */
	.form-item-input {
		width: 400px;
	}

	/**输入框后面的备注 */
	.form-item-tip {
		display: inline-block;
		margin-left: 10px;
		color: #606266;
		font-size: 14px;
	}

	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 178px;
		height: 178px;
		line-height: 178px;
		text-align: center;
	}

	.avatar {
		width: 178px;
		height: 178px;
		display: block;
	}

	.shangchuantupian {
		margin-left: 80px;
		margin-bottom: 20px;
		width: 80%;



	}

	/* 主体容器 */
	.maina {
		height: 100%;
		/* overflow: hidden; */
		background-color: #fff;
		padding: 10px;
		box-sizing: border-box;
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
	}

	/* 主体容器 */
	.mainxjgda {
		height: 100%;
		/* overflow: hidden; */
		background-color: #fff;
		padding: 0px;
		margin-top: 20px;
		box-sizing: border-box;
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
	}

	.el-card {
		box-shadow: 0 1px 1px #F5F5F5 !important;
	}


	.shangchuantupianx {
		margin-left: 10px;
		margin-top: 10px;

		display: inline-block;
	}

	.medium {
		width: 400px;
		height: 30px;
		text-align: left;
		color: #999999;
		font-weight: 400;
	}

	.mediuma {
		width: 400px;
		height: 30px;
		text-align: left;
		color: #333333;
		font-weight: 400;
	}

	/**输入框宽度 */
	.form-item-inputcpx {
		width: 400px;
	}

	/deep/.eloption .el-select-dropdown__wrap {
		max-height: 400px !important;
	}


	.fankuiImage {
		width: 100%;
		height: 100%;



	}
	.el-table {
		overflow-y: auto !important;
		overflow-x: auto !important;
	}
</style>
